import { Car, Calendar } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { Driver } from "@/types";
import { formatUserName } from "@/utils/userName";

interface DriverCardProps {
  driver: Driver;
  onClick: () => void;
}

export default function DriverCard({ driver, onClick }: DriverCardProps) {
  const { t, i18n } = useTranslation("pages");

  return (
    <div
      onClick={onClick}
      className="bg-white rounded-lg border border-secondary-200 px-4 py-3 cursor-pointer hover:border-secondary-300 transition-colors"
    >
      <div className="flex items-center gap-4">
        <h3 className="text-base font-semibold text-secondary-900 min-w-40">
          {formatUserName(driver)}
        </h3>
        <div className="flex items-center gap-x-4 text-sm text-secondary-500 flex-wrap">
          <span className="flex items-center gap-1">
            <Car className="h-3.5 w-3.5" />
            {t("drivers.vehicles", { count: driver.vehicleCount })}
          </span>
          <span className="flex items-center gap-1">
            <Calendar className="h-3.5 w-3.5" />
            {t("drivers.sessions", { count: driver.sessionCount })}
          </span>
          <span className="text-secondary-400">
            {t("drivers.joined", {
              date: new Date(driver.createdAt).toLocaleDateString(i18n.language),
            })}
          </span>
        </div>
      </div>
    </div>
  );
}
